module.exports = __webpack_public_path__ + "static/siteHeader-b69d43de202f26d6c3bf296d44880c1a.jpg";